import React from "react";
import { Link } from "react-router-dom";
import PermissionGuard from "./PermissionGuard";
import { useTranslation } from "react-i18next";
import { localize } from "../helpers/function";

const UnitTableRow = ({ unit, onDelete, showInstitution }) => {
  const { t } = useTranslation();

  return (
    <tr role="row" className="odd">
      <td>{unit.name && localize(unit.name)}</td>
      <td>
        {unit.unit_type && localize(unit.unit_type.name)}
      </td>
      <td>
        {unit.parent && localize(unit.parent.name)}
      </td>
      <td>
        {unit.state && unit.state.country ? unit.state.country.name : "-"}
      </td>
      <td>
        {unit.state ? unit.state.name : "-"}
      </td>
      <td>
        {unit.lead
          ? unit.lead.identite
            ? unit.lead.identite.lastname + " " + unit.lead.identite.firstname
            : "-"
          : "-"}
      </td>
      {showInstitution && (
        <td >
          {unit.institution ? unit.institution.name : null}
        </td>
      )}
      <td>
        <PermissionGuard
          permissions={[
            "update-any-unit",
            "update-my-unit",
            "update-without-link-unit",
          ]}
        >
          <Link
            to={`/settings/unit/${unit.id}/edit`}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Modifier")}
          >
            <i className="la la-edit" />
          </Link>
        </PermissionGuard>

        <PermissionGuard
          permissions={[
            "destroy-any-unit",
            "destroy-my-unit",
            "destroy-without-link-unit",
          ]}
        >
          <button
            onClick={() => onDelete(unit.id)}
            className="btn btn-sm btn-clean btn-icon btn-icon-md"
            title={t("Supprimer")}
          >
            <i className="la la-trash" />
          </button>
        </PermissionGuard>
      </td>
    </tr>
  );
};

export default UnitTableRow;
